import { render, staticRenderFns } from "./develop-configuration.vue?vue&type=template&id=2cb39768&scoped=true"
import script from "./develop-configuration.vue?vue&type=script&lang=js"
export * from "./develop-configuration.vue?vue&type=script&lang=js"
import style0 from "./develop-configuration.vue?vue&type=style&index=0&id=2cb39768&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb39768",
  null
  
)

export default component.exports